.kbd {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-family: var(--font-ui);
  font-size: 10px;
  font-weight: 500;
  color: var(--text-muted);
}

.key {
  background: var(--surface-active);
  border-radius: var(--radius-xs);
  padding: 2px 4px;
  line-height: 1;
  min-width: 14px;
  text-align: center;
}
